import apiClient from './api';
import {
  CustomerValidationResponse,
  CreateCustomerRequest,
  CustomerCreationResponse,
  ApiResponse
} from '../types/sistematizacion.types';

/**
 * Servicio para validar y gestionar clientes en SAP B1
 */
export const customerService = {
  /**
   * Valida si un cliente existe en SAP B1 por su identificación
   */
  validateCustomer: async (
    identification: string
  ): Promise<ApiResponse<CustomerValidationResponse>> => {
    try {
      const response = await apiClient.get<ApiResponse<CustomerValidationResponse>>(
        `/Customer/validate/${identification}`
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        return error.response.data;
      }
      throw error;
    }
  },

  /**
   * Obtiene información completa de un cliente por su identificación
   */
  getCustomerByIdentification: async (
    identification: string
  ): Promise<ApiResponse<CustomerValidationResponse>> => {
    try {
      const response = await apiClient.get<ApiResponse<CustomerValidationResponse>>(
        `/Customer/validate/${identification}`
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        return error.response.data;
      }
      throw error;
    }
  },

  /**
   * Crea un nuevo cliente en SAP B1
   */
  createCustomer: async (
    request: CreateCustomerRequest
  ): Promise<ApiResponse<CustomerCreationResponse>> => {
    try {
      const response = await apiClient.post<ApiResponse<CustomerCreationResponse>>(
        `/Customer/create`,
        request
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        return error.response.data;
      }
      throw error;
    }
  }
};

export default customerService;
